import { makeStyles } from '@material-ui/core/styles';
import { ISpcTheme } from '../../../../../../common/theme/ISpcTheme';

export type OptionPriceMultiCurrencyClasses =
  | 'accessoryPriceLabel'
  | 'accessoryPrice'
  | 'orLabel'
  | 'secondaryAccessoryPrice'
  | 'container';

const optionPriceMultiCurrencyStyles = makeStyles<ISpcTheme, OptionPriceMultiCurrencyClasses>(
  theme => ({
    container: {
      width: '100%',
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'space-between',
    },
    accessoryPriceLabel: {
      fontSize: theme.typography.fontSM,
      fontFamily: theme.typography.fontFamily2,
      paddingRight: theme.spacing(0.5),
    },
    accessoryPrice: {
      fontSize: theme.typography.fontSM,
      fontFamily: theme.typography.fontFamily2,
      [theme.breakpoints.down('sm')]: {
        fontSize: theme.typography.fontXS,
      },
      // Custom breakpoint as it won't fit when it's multi currencies
      [theme.breakpoints.down(370)]: {
        fontSize: theme.typography.fontXXS,
      },
    },
    secondaryAccessoryPrice: {
      fontSize: theme.typography.fontSM,
      [theme.breakpoints.down('sm')]: {
        fontSize: theme.typography.fontXS,
      },
      // Custom breakpoint as it won't fit when it's multi currencies
      [theme.breakpoints.down(370)]: {
        fontSize: theme.typography.fontXXS,
      },
    },
    orLabel: {
      padding: '0 5px',
      fontSize: theme.typography.fontSM,
      marginTop: 2,
    },
  }),
  { name: 'Customise_OptionPriceMultiCurrency' },
);

export default optionPriceMultiCurrencyStyles;
